const properties = [
  'userAgent.usertype',
  'ipapp.info.id',
  'ipapp.info.RefreshToken',
  'ipapp.info.AccessToken',
  'navi.subscription.status',
  'Navi.Subscription.date',
  'userAgent.AuthenticationToken',
  'VirtualAssistant.subscription.stausOnUserProfile',
  'VirtualAssistant.subscription.date',
];

export default {
  properties,
};
